import { Component, Input } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { FormGroupComponent } from '@tecalisdev/infinity';

import { IFormFieldPreset } from '../form-field-presets';
import { presetRequiresFieldTitle } from '../form-step-field-title.util';
import { FormStepFieldPreviewListComponent } from './form-step-field-preview-list.component';
import { FormStepFieldTitleConfigComponent } from './form-step-field-title-config.component';
import { FormStepOptionsEditorComponent } from './form-step-options-editor.component';
import { FormStepRichTextOptionsEditorComponent } from './form-step-rich-text-options-editor.component';
import { FormStepYesNoPreviewComponent } from './form-step-yes-no-preview.component';

@Component({
	selector: 'app-form-step-fields-section',
	imports: [
		ReactiveFormsModule,
		TranslatePipe,
		FormGroupComponent,
		FormStepFieldTitleConfigComponent,
		FormStepOptionsEditorComponent,
		FormStepRichTextOptionsEditorComponent,
		FormStepYesNoPreviewComponent,
		FormStepFieldPreviewListComponent,
	],
	templateUrl: './form-step-fields-section.component.html',
	styleUrl: './form-step-fields-section.component.scss',
})
export class FormStepFieldsSectionComponent {
	@Input({ required: true }) form!: FormGroup;
	@Input({ required: true }) fieldsArray!: FormArray;
	@Input() preset?: IFormFieldPreset;
	@Input() primaryField: FormGroup | null = null;
	@Input() selectedLocaleId = 'es';

	public get usesOptionsEditor(): boolean {
		return Boolean(this.preset?.usesOptionsEditor);
	}

	public get usesRichTextOptionsEditor(): boolean {
		return Boolean(this.preset?.usesRichTextOptionsEditor);
	}

	public get usesYesNoPreview(): boolean {
		return Boolean(this.preset?.usesYesNoPreview);
	}

	public get usesLegalFieldsConfig(): boolean {
		return Boolean(this.preset?.usesLegalFieldsConfig);
	}

	public get hidesFieldTitleConfig(): boolean {
		return (
			this.usesOptionsEditor ||
			this.usesRichTextOptionsEditor ||
			this.usesYesNoPreview ||
			this.usesLegalFieldsConfig
		);
	}

	public get fieldTitleRequired(): boolean {
		return presetRequiresFieldTitle(this.preset);
	}

	public get wrapFieldsInFormGroup(): boolean {
		return this.usesOptionsEditor || (this.usesRichTextOptionsEditor && !this.usesLegalFieldsConfig);
	}

	public get fieldsDescriptionKey(): string {
		if (this.usesLegalFieldsConfig) {
			return 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_LEGAL_DESCRIPTION';
		}

		if (this.usesYesNoPreview) {
			return 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_YES_NO_DESCRIPTION';
		}

		if (this.usesRichTextOptionsEditor) {
			return 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_CHECKBOX_DESCRIPTION';
		}

		if (this.usesOptionsEditor) {
			return 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_OPTIONS_DESCRIPTION';
		}

		return 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_DESCRIPTION';
	}
}
